"use client"

import styled from "@emotion/styled"
import { Avatar, Box, Typography } from "@mui/material"
import { mediaQueries } from "ui"
import ButtonWithArrow from "ui/common/bit/ButtonWithArrow"
import { sizes } from "ui/theme/theme"

const StyledPersonContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${sizes.baseDouble};
  text-align: center;
  height: 100%;
`

const StyledAvatar = styled(Avatar)`
  min-width: 140px;
  min-height: 140px;
  margin-bottom: ${sizes.baseDouble};
  ${mediaQueries.tablet} {
    min-width: 180px;
    min-height: 180px;
  }
`

const StyledName = styled(Typography)<{ component?: string }>`
  font-weight: 700;
  margin-bottom: ${sizes.baseHalf};
`

const StyledRole = styled(Typography)`
  margin-bottom: ${sizes.baseDouble};
`

const StyledButtonContainer = styled(Box)`
  margin-top: auto;
  padding-top: ${sizes.baseDouble};
`
const StyledButtonWithArrow = styled(ButtonWithArrow)``

interface Person {
  fullName: string
  text: string
  role: string
  image: {
    src: string
    alt: string
    width: string
    height: string
  }
  facebookLink: { text: string; href: string }
  linkedinLink: { text: string; href: string }
}

interface PeopleItemProps {
  person: Person
  onClick: () => void
}

const PeopleItem = ({ person, onClick }: PeopleItemProps) => {
  return (
    <StyledPersonContainer>
      <StyledAvatar
        src={person.image.src}
        alt={person.image.alt || person.fullName}
      />
      <StyledName variant="h5" component="p">
        {person.fullName}
      </StyledName>
      <StyledRole variant="body1">{person.role}</StyledRole>

      <StyledButtonContainer>
        <StyledButtonWithArrow
          onClick={onClick}
          colorPallette="orange"
          variant="elevated"
        >
          לקרוא עוד
        </StyledButtonWithArrow>
      </StyledButtonContainer>
    </StyledPersonContainer>
  )
}

export default PeopleItem
